import type { ColumnMapping } from "./types";

export function hasBlockingUploadMappingItems(items: ColumnMapping[]): boolean {
  return items.some(item => item.valid && !item.disabled && item.type !== "parameter" && item.type !== "measurement");
}
